import { Spin as AntSpin } from 'antd';
import type { SpinProps } from 'antd';
import styled, { keyframes } from 'styled-components';

const DOT_COUNT = 8;
const DOTS = Array.from({ length: DOT_COUNT });
const DOT_KEYS = Array.from({ length: DOT_COUNT }, (_, index) => `spin-dot-${index}`);

const ringRotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const RingIndicator = styled.span`
  animation: ${ringRotate} 1s steps(${DOT_COUNT}, end) infinite;

  i {
    position: absolute;
    top: 0;
    left: 50%;
    width: 0.25em;
    height: 0.25em;
    margin-left: -0.125em;
    border-radius: 50%;
    transform-origin: 0.125em 0.5em;
  }

  ${DOTS.map((_, index) => {
    const strength = Math.max(100 - index * 13, 9);
    return `
      i:nth-child(${index + 1}) {
        transform: rotate(${(index * 360) / DOT_COUNT}deg);
        background-color: rgba(var(--clr-general-primary-rgb), ${strength / 100});
        background-color: color-mix(
          in srgb,
          var(--clr-general-primary) ${strength}%,
          var(--clr-white)
        );
      }
    `;
  }).join('')}
`;

const StyledSpin = styled(AntSpin)``;

export const Spin = (props: SpinProps) => (
  <StyledSpin
    indicator={
      <RingIndicator>
        {DOT_KEYS.map((key) => (
          <i key={key} />
        ))}
      </RingIndicator>
    }
    {...props}
  />
);
